/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import restClient from '../../app/helpers/restClient';

const getBraintreePayPalClientToken = (wcEnv, jwtToken, orderId, params) => {
    const env = wcEnv;
    env.rootUri = '/mbp-canada-checkout';
    const resourcePage = '/payment/clienttoken';

    return restClient.getFacade(env, resourcePage, jwtToken, params)
        .then((response) => response);
};

export default getBraintreePayPalClientToken;
